/**
 * TourStep — content for a spotlight tour step: a heading and description shown
 * in the tooltip that points at the highlighted element.
 *
 * Presentational only — text comes from the caller.
 */

import React from "react";
import { Typography } from "antd";
import { TourStepStyled } from "./SbTour.styles";

const { Title, Paragraph } = Typography;

const TourStep = ({ title, description }) => (
  <TourStepStyled vertical gap="small">
    <Title level={5}>{title}</Title>
    {String(description)
      .split("\n\n")
      .map((para, i) => (
        <Paragraph key={i} type="secondary">
          {para}
        </Paragraph>
      ))}
  </TourStepStyled>
);

export default TourStep;
